export default {"src":"https://search.testwiggot.com/_next/static/media/wiggot-switch-icon.23e2c628.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};